import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandlerFn,
    HttpHeaders,
    HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from 'app/core/auth/auth.service';
import { AuthUtils } from 'app/core/auth/auth.utils';
import { catchError, Observable, throwError } from 'rxjs';

/**
 * Intercept
 *
 * @param req
 * @param next
 */
export const authInterceptor = (
    req: HttpRequest<unknown>,
    next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
    const authService = inject(AuthService);

    // Clone the request object
    let newReq = req.clone();
    let poolId = localStorage.getItem('user_pool_id') || '';
    let localData = AuthUtils.getUrlsLocalStorage();
    // Request
    //
    // If the access token didn't expire, add the Authorization header.
    // We won't add the Authorization header if the access token expired.
    // This will force the server to return a "401 Unauthorized" response
    // for the protected API routes which our response interceptor will
    // catch and delete the access token from the local storage while logging
    // the user out from the app.

    if (
        authService.accessToken.t &&
        req.url.includes('https://connectone.frappe.cloud/')
    ) {
        const headers = new HttpHeaders({
            // Authorization: 'Bearer ' + this.authService.accessToken.t,
            // Authorization: localData.erpnext_token,
        });
        newReq = req.clone({ headers });
    }
    if (
        authService.accessToken.t &&
        !req.url.includes('tenantmaster/details') &&
        !req.url.includes('https://connectone.frappe.cloud/') &&
        !req.url.includes('/openapis/')
    ) {
        const headers = new HttpHeaders({
            Authorization: 'Bearer ' + authService.accessToken.t,
            'x-userpool-id': poolId,
            // 'X-Name-No': environment.xNameNo,
        });
        newReq = req.clone({ headers });
    } else {
        newReq = req.clone({
            // headers: req.headers.set('X-Name-No', environment.xNameNo),
        });
    }

    // Response handling and error interception
    return next(newReq).pipe(
        catchError((error: HttpErrorResponse) => {
            console.log(error.error, 'error');

            // Check for specific status codes or error messages
            if (shouldSignOut(error)) {
                authService.signOut();
                // Optionally reload the application to reset state
                // location.reload();
            }

            return throwError(() => error.error);
        })
    );

    // Helper function to determine if a sign-out is necessary
    function shouldSignOut(error: HttpErrorResponse): boolean {
        if (error.status === 401) return true;
        if (error.error?.status_description) {
            const desc = error.error.status_description;
            return (
                desc.includes('The Token has expired on') ||
                desc.includes('User not Authorized')
            );
        }
        return false;
    }
};
